import shopifyPursuitGenericDefaults from '../shopify-pursuit-generic/config.js';

const isB2B = !!window.Convermax?.Shopify?.getCompanyId();
window.Convermax.isB2B = isB2B;

const getItemId = ({ getItemId, _ }) => {
  if (window.Convermax.Shopify.listedVariantId) {
    return window.Convermax.Shopify.listedVariantId;
  }

  return getItemId();
};

window.Convermax.openCustomKlaviyoDialog = (product) => {
  window.Convermax.klaviyoModalActiveProduct = product;

  window.Convermax.openDialog('CustomKlaviyoDialog');
};

window.Convermax.addBackInStockSubscribe = () => {
  const submitBtn = window.document.querySelector('#klaviyo-bis-modal .cm_klaviyo-dialog_btn');
  const completeMessage = window.document.querySelector('#klaviyo-bis-modal #completed_message');
  const errorMessage = window.document.querySelector('#klaviyo-bis-modal #error_message');

  const userEmail = window.document.querySelector('#klaviyo-bis-modal #email').value;

  const variantSelect = window.document.querySelector('#variants');
  const variantId = variantSelect.options[variantSelect?.selectedIndex].getAttribute('data-variant-id');

  if (!userEmail) {
    errorMessage.innerHTML = 'Please provide a valid email address.';
    errorMessage.style.display = 'block';
    return;
  }

  submitBtn.setAttribute('disabled', 'true');

  const data = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: userEmail,
            },
          },
        },
        channels: ['EMAIL'],
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${variantId}`,
          },
        },
      },
    },
  };

  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=SseSyr', {
    method: 'POST',
    headers: {
      'revision': '2025-01-15',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} status error. Please try again later.`);
      }

      submitBtn.style.display = 'none';
      completeMessage.style.display = 'block';
    })
    .catch((err) => {
      submitBtn.removeAttribute('disabled');
      errorMessage.innerHTML = err.message;
      errorMessage.style.display = 'block';
      console.error(err);
    });
};

window.Convermax.handlePDPTableTabs = (e, partNumber, selector) => {
  const interchangeTabsContainer = e.currentTarget.parentElement.parentElement;
  if (interchangeTabsContainer) {
    const currentActiveTab = interchangeTabsContainer.querySelector(`.${selector}-button-active`);
    if (currentActiveTab) {
      currentActiveTab.classList.remove(`${selector}-button-active`);
    }

    const currentActiveContent = interchangeTabsContainer.querySelector(`.${selector}-content-active`);
    if (currentActiveContent) {
      currentActiveContent.classList.remove(`${selector}-content-active`);
    }

    const clickedTab = e.currentTarget;
    if (clickedTab) {
      clickedTab.classList.add(`${selector}-button-active`);
    }

    const clickedTabContent = window.document.querySelector(`.${selector}-content-${partNumber}`);
    if (clickedTabContent) {
      clickedTabContent.classList.add(`${selector}-content-active`);
    }
  }
};

window.Convermax.showMoreProductData = (e) => {
  const interchangeTabsContainer = e.currentTarget?.parentElement?.parentElement;
  if (interchangeTabsContainer) {
    const collapseButton = interchangeTabsContainer.querySelector('.cm_fitment-table_collapse-button');
    const collapsedContent = interchangeTabsContainer.querySelector('.fitment-table-body-collapsible');

    if (collapseButton) {
      const isCollapsed = collapseButton.innerText === 'SHOW MORE';
      const hiddenRows = interchangeTabsContainer.querySelectorAll('.fitment-row[cm-data-hidden="true"]');

      if (isCollapsed) {
        collapseButton.textContent = 'Show Less';
        collapsedContent.classList.remove('cm_fitment-table-body-content-collapsed');
        hiddenRows.forEach((row) => {
          row.classList.remove('cm_hide');
        });
      } else {
        collapseButton.textContent = 'Show More';
        collapsedContent.classList.add('cm_fitment-table-body-content-collapsed');
        hiddenRows.forEach((row) => {
          row.classList.add('cm_hide');
        });
      }
    }
  }
};

window.Convermax.addItemToCart = (e, variantId) => {
  e.preventDefault();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  }).then((response) => {
    return response.json();
  });
};

window.Convermax.productCardCarousel = (event, isNext) => {
  event.preventDefault();
  event.stopPropagation();

  const carouselWrapper = event.currentTarget.closest('.product-grid-image-carousel-wrapper');
  if (!carouselWrapper) {
    return;
  }

  const carousel = carouselWrapper.querySelector('.product-grid-image-carousel');
  const carouselItems = Array.from(carouselWrapper.querySelectorAll('.product-grid-image-carousel-item'));
  if (!carousel || carouselItems.length < 3) {
    return;
  }

  const currentIndex = parseInt(carouselWrapper.dataset.carouselIndex || '0', 10) || 0;
  const lastIndex = carouselItems.length - 1;
  const nextIndex = Math.min(Math.max(currentIndex + (isNext ? 1 : -1), 0), lastIndex);
  const activeItem = carouselItems[nextIndex];
  const lastItem = carouselItems[lastIndex];
  const contentWidth = carousel.scrollWidth || lastItem.offsetLeft + lastItem.offsetWidth;
  const leftBound = 0;
  const rightBound = Math.min(carouselWrapper.clientWidth - contentWidth, 0);
  const centerOffset = carouselWrapper.clientWidth / 2 - activeItem.offsetLeft - activeItem.offsetWidth / 2;
  const carouselOffset =
    nextIndex === 0
      ? leftBound
      : nextIndex === lastIndex
        ? rightBound
        : Math.min(Math.max(centerOffset, rightBound), leftBound);

  carouselWrapper.dataset.carouselIndex = `${nextIndex}`;
  carousel.style.transform = `translateX(${carouselOffset}px)`;

  carouselWrapper
    .querySelector('.product-grid-image-carousel-button_prev')
    ?.classList.toggle('product-grid-image-carousel-button_hidden', nextIndex === 0);
  carouselWrapper
    .querySelector('.product-grid-image-carousel-button_next')
    ?.classList.toggle('product-grid-image-carousel-button_hidden', nextIndex === lastIndex);

  carouselWrapper
    .querySelectorAll('.product-grid-image-carousel-scrollbar-item')
    .forEach((scrollbarItem, index) => {
      scrollbarItem.classList.toggle('active', index === nextIndex);
    });
};

const updateFitmentNotesLayout = () => {
  const notes = window.document.querySelector(
    '.cm_vehicle-widget__verify-fitment .cm_product-fitment-notes_collapsible',
  );
  const text = notes?.querySelector('p');
  const chevron = notes?.querySelector('span');

  if (!text || !chevron) {
    return;
  }

  chevron.classList.add('cm_hide');

  const style = window.getComputedStyle(text);
  const lineHeight = parseFloat(style.lineHeight);
  const fontSize = parseFloat(style.fontSize);
  const lineHeightPx = Number.isFinite(lineHeight) ? lineHeight : fontSize * 1.2;
  const hasOverflow = text.scrollHeight > lineHeightPx * 2 + 1;

  if (hasOverflow) {
    chevron.classList.remove('cm_hide');
  }
};

const onVerifyFitmentResponseReceived = () => {
  shopifyPursuitGenericDefaults.onVerifyFitmentResponseReceived?.();
  setTimeout(() => updateFitmentNotesLayout(), 0);
};

function InitFunc() {
  shopifyPursuitGenericDefaults.InitFunc?.();

  if (window.location.hash === '#cm-fitment-table') {
    // Scroll to the fitment table if the URL contains the corresponding hash
    const target = window.document.querySelector('#cm-fitment-table');
    if (target) {
      const headerOffset = window.document.querySelector('.main-header')?.offsetHeight + 20 || 170;
      const y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top: y });
    }
  }
}

const AfterInit = () => {
  shopifyPursuitGenericDefaults.AfterInit?.();

  // Close the YMM panel in burger menu when closing the menu itself
  const burgerClose = window.document.querySelector('.close-mobile-nav.js-nav-control');
  if (burgerClose) {
    const navYmmClose = window.document.querySelector('.component-easy-search .filters-top-navigation');
    burgerClose.addEventListener('click', () => navYmmClose?.click());
  }

  const header = window.document.querySelector('header.main-header');
  const resultsHeader = window.document.querySelector('.cm_results-header');
  if (window.innerWidth <= 991 && header && resultsHeader) {
    const resultsHeaderTop = resultsHeader.getBoundingClientRect().top + window.scrollY;

    window.document.addEventListener('scroll', () => {
      const headerBottom = header.getBoundingClientRect().bottom;
      const isSticky = window.scrollY + headerBottom >= resultsHeaderTop;

      resultsHeader.classList.toggle('cm_results-header-sticky', isSticky);

      if (isSticky) {
        resultsHeader.style.setProperty('top', `${Math.max(headerBottom, 0)}px`);
      } else {
        resultsHeader.style.removeProperty('top');
      }
    });

    window.document.dispatchEvent(new Event('scroll'));
  }

  window.addEventListener('resize', updateFitmentNotesLayout, { passive: true });

  window.document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const cmElement = event.target.closest('[class^="cm_"], [class*=" cm_"], [id^="cm_"], [id^="cm-"]');

      if (
        cmElement &&
        cmElement !== document.body &&
        cmElement !== document.documentElement &&
        typeof event.isImmediatePropagationStopped !== 'function'
      ) {
        event.isImmediatePropagationStopped = () => false;
      }
    },
    true,
  );
};

export default {
  ...shopifyPursuitGenericDefaults,
  includes: ['shopify-pursuit-generic'],
  InitFunc,
  AfterInit,
  collapsibleAnimationTime: 0,
  product: {
    ...shopifyPursuitGenericDefaults.product,
    searchResultsImageWidth: 800,
    searchResultsImageHeight: 800,
    getItemId,
  },
  fitmentSearch: {
    ...shopifyPursuitGenericDefaults.fitmentSearch,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
    onVerifyFitmentResponseReceived,
  },
  Widgets: [
    ...shopifyPursuitGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'CategoryPage',
          'SearchHeader',
          'SearchBox',
          'SearchBoxDialogButton', // They use desktop autocomplete on mobile
          'HeaderVehicleWidget',
          'SearchVehicleWidget',
          'FacetCategoryTiles',
          'FacetBrandTiles',
          'FitmentTable',
          'VehicleWidgetDialog',
        ].includes(w.name),
    ),
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm-collection-page',
      template: 'SearchPage',
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'SearchHeader'),
      doNotHideOnNoResults: window.innerWidth <= 991,
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      onSubmit: () => window.document.querySelector('#search-pop #button-search-close')?.click(),
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      type: 'SearchBox',
      name: 'MobileSearchBox',
      location: {
        selector: '#cm-search-box',
        class: 'mobile-search-wrap search-form__container cm_search-box-root__mobile',
      },
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: { selector: '#cm-ymm', class: 'cm_vehicle-widget__home-desktop' },
      template: 'fitmentSearch/homeVehicleWidget',
      initCollapsed: true,
      isAlwaysActive: true,
    },
    {
      name: 'HomeVehicleWidget_mobile',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-mobile-ymm-sticky',
        class: 'cm_desktop-hide',
      },
      template: 'fitmentSearch/headerMobileHomeVehicleWidget',
      initCollapsed: true,
      isAlwaysColumnLayout: true,
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'SearchVehicleWidget'),
      initCollapsed: true,
      isAlwaysColumnLayout: true,
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'SearchVehicleWidget'),
      name: 'SearchVehicleWidget_mobile',
      initCollapsed: true,
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm-header',
      template: 'fitmentSearch/headerVehicleWidget',
      columnBreakpoint: 0, // always use horizontal layout
    },
    {
      name: 'HeaderVehicleWidget_mobile-menu',
      type: 'VehicleWidget',
      location: { selector: '#cm-ymm-burger-menu', class: 'cm_vehicle-widget__mobile-menu' },
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: true,
    },
    {
      name: 'HeaderVehicleWidget_sidecart',
      type: 'VehicleWidget',
      location: '#cm-ymm-cart-popup',
      template: 'fitmentSearch/sidecartVehicleWidgetDialog',
      doNotRedirectOnVehicleSelect: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'VerifyFitmentSticky',
      type: 'VerifyFitment',
      location: {
        selector: '#cm-verify-fitment-sticky',
        class: 'cm_vehicle-widget__verify-fitment_sticky',
      },
      template: 'fitmentSearch/stickyVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: true,
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'FacetCategoryTiles'),
      isVehicleWidgetDisabled: true,
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'FacetBrandTiles'),
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: { replace: '.cm_fitment-table-tab', class: 'cm_tab-title cm_fitment-table-tab active' },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'FitmentTable'),
      columnBreakpoint: 0, // always use horizontal layout
      alwaysShowedCount: 5,
    },
    {
      name: 'InterchangesTab',
      type: 'ProductData',
      location: { replace: '.cm_interchange-tab', class: 'cm_tab-title cm_interchange-tab' },
      template: 'product/interchangesTab',
      fields: ['interchanges'],
    },
    {
      name: 'Interchanges',
      type: 'ProductData',
      location: '.cm_interchange-tab-content',
      template: 'product/interchanges',
      fields: ['interchanges'],
    },
    {
      name: 'ProductSpecifications',
      type: 'ProductData',
      location: { lastChildOf: 'body.template-product .cm_tabs-container' },
      template: 'product/specifications',
      fields: ['specifications'],
    },
    {
      ...shopifyPursuitGenericDefaults.Widgets.find((w) => w.name === 'VehicleWidgetDialog'),
      doNotRedirectOnVehicleSelect: window.Convermax?.Shopify?.pageType === 'collection',
    },
    {
      name: 'CustomKlaviyoDialog',
      type: 'ContextDialog',
      template: 'KlaviyoDialog',
    },
  ],
};

/* eslint-disable camelcase */
window.Convermax.shopPayTerms = {
  currency_code: 'USD',
  country_code: 'US',
  min_price: '$35.00',
  max_price: '$30,000.00',
  financing_plans: [
    {
      min_price: '$35.00',
      max_price: '$49.99',
      terms: [{ apr: 0, loan_type: 'split_pay', installments_count: 2 }],
    },
    {
      min_price: '$50.00',
      max_price: '$149.99',
      terms: [{ apr: 0, loan_type: 'split_pay', installments_count: 4 }],
    },
    {
      min_price: '$150.00',
      max_price: '$999.99',
      terms: [
        { apr: 0, loan_type: 'split_pay', installments_count: 4 },
        { apr: 15, loan_type: 'interest', installments_count: 3 },
        { apr: 15, loan_type: 'interest', installments_count: 6 },
        { apr: 15, loan_type: 'interest', installments_count: 12 },
      ],
    },
    {
      min_price: '$1,000.00',
      max_price: '$30,000.00',
      terms: [
        { apr: 15, loan_type: 'interest', installments_count: 3 },
        { apr: 15, loan_type: 'interest', installments_count: 6 },
        { apr: 15, loan_type: 'interest', installments_count: 12 },
      ],
    },
  ],
  installments_buyer_prequalification_enabled: false,
  seller_id: 482728,
};
/* eslint-enable camelcase */
